﻿﻿export interface ISaveShortCodeLinkRequest {
    link: string;
    shortCode: string;
}
